import ManagementsClaims from "../../components/ManagementsClaims/ManagementsClaims";

function ManagementsClaimsPage() {
  return (
      <ManagementsClaims />
  );
}

export default ManagementsClaimsPage;
